import { render, staticRenderFns } from "./PointSecuritymoneyConfirm.vue?vue&type=template&id=5f669777"
import script from "./PointSecuritymoneyConfirm.vue?vue&type=script&lang=js"
export * from "./PointSecuritymoneyConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports